import { Badge } from "./Badge";
import {
  AppointmentStatus,
  AppointmentPaymentStatus,
  AppointmentChargeStatus,
  getAppointmentStatusColor,
  getAppointmentStatusLabel,
  getChargeStatusColor,
  getChargeStatusLabel,
  getPaymentStatusColor,
  getPaymentStatusLabel,
} from "@/api/enums";

interface StatusBadgeProps {
  status: AppointmentStatus | AppointmentPaymentStatus | AppointmentChargeStatus;
  type: "primary" | "payment" | "charge";
  className?: string;
}

const COLOR_MAP = {
  warning: "bg-[var(--color-status-warning-bg)] text-[var(--color-status-warning)] border-[var(--color-status-warning)]/30",
  info: "bg-[var(--color-status-info-bg)] text-[var(--color-status-info)] border-[var(--color-status-info)]/30",
  success: "bg-[var(--color-status-success-bg)] text-[var(--color-status-success)] border-[var(--color-status-success)]/30",
  error: "bg-[var(--color-status-error-bg)] text-[var(--color-status-error)] border-[var(--color-status-error)]/30",
  neutral: "bg-muted text-muted-foreground border-border",
} as const;

export function StatusBadge({ status, type, className = "" }: StatusBadgeProps) {
  const label =
    type === "charge"
      ? getChargeStatusLabel(status as AppointmentChargeStatus)
      : type === "payment"
        ? getPaymentStatusLabel(status as AppointmentPaymentStatus)
        : getAppointmentStatusLabel(status as AppointmentStatus);

  if (!label?.trim()) return null;

  const color =
    type === "charge"
      ? getChargeStatusColor(status as AppointmentChargeStatus)
      : type === "payment"
        ? getPaymentStatusColor(status as AppointmentPaymentStatus)
        : getAppointmentStatusColor(status as AppointmentStatus);

  return (
    <Badge className={`text-xs font-medium border ${COLOR_MAP[color]} ${className}`.trim()}>
      {label}
    </Badge>
  );
}
